<!-- @format -->

<template>
    <div class="gst-hotel-no-data-replace py-md-9 py-8 px-8">
        <h5>{{ $t('message') }}</h5>
        <BaseButton
            :placeholder="$t('buttons.refund')"
            color="primary"
            @click="onClickRefundDo" />
        <SupportSection />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '@core/shared/components/buttons/BaseButton';
import SupportSection from '@tenant/app/modules/hotel/components/SupportSection.vue';

export default {
    name: 'HotelsNoData',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking._components.hotelsNoData',
    },
    components: {
        BaseButton,
        SupportSection,
    },
    computed: {
        ...mapGetters({
            bookingCartId: 'booking/getCartId',
        }),
        computedCartId() {
            return this.bookingCartId || this.$route.params.id;
        },
    },
    methods: {
        onClickRefundDo() {
            this.$router.push({
                name: 'booking.refund.checkout',
                params: { id: this.computedCartId },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-hotel-no-data-replace {
    line-height: normal;
    text-align: center;

    h5 {
        padding-bottom: theme-spacing(9);
        font-size: font-size('xxl');
        font-weight: font-weight('large');
    }

    .gst-btn {
        margin-bottom: theme-spacing(8) !important;
    }

    .gst-support-section {
        text-align: left;
    }
}
</style>
